/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ArchitectsControllerFindAllQueryResponse, ArchitectsControllerFindAllQueryParams, ArchitectsControllerFindAll401, ArchitectsControllerFindAll403 } from "../../models/architectsController/ArchitectsControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { architectsControllerFindAll } from "../../clients/architectsService/architectsControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const architectsControllerFindAllQueryKey = (params: ArchitectsControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/architects'
}, ...(params ? [params] : [])] as const;
export type ArchitectsControllerFindAllQueryKey = ReturnType<typeof architectsControllerFindAllQueryKey>;
export function architectsControllerFindAllQueryOptions(params?: ArchitectsControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = architectsControllerFindAllQueryKey(params);
  return queryOptions<ArchitectsControllerFindAllQueryResponse, ResponseErrorConfig<ArchitectsControllerFindAll401 | ArchitectsControllerFindAll403>, ArchitectsControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return architectsControllerFindAll(params, config);
    }
  });
}

/**
 * @summary Get all architects
 * {@link /api/v1/architects}
 */
export function useArchitectsControllerFindAll<TData = ArchitectsControllerFindAllQueryResponse, TQueryData = ArchitectsControllerFindAllQueryResponse, TQueryKey extends QueryKey = ArchitectsControllerFindAllQueryKey>(params?: ArchitectsControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<ArchitectsControllerFindAllQueryResponse, ResponseErrorConfig<ArchitectsControllerFindAll401 | ArchitectsControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? architectsControllerFindAllQueryKey(params);
  const query = useQuery({
    ...architectsControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ArchitectsControllerFindAll401 | ArchitectsControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}